import {
  FaBriefcase,
  FaLaptopCode,
  FaChartLine,
  FaPaintBrush,
  FaHeadset,
  FaShieldAlt,
  FaCloud,
  FaBullhorn,
  FaCog,
  FaUsers,
  FaDatabase,
  FaGlobe,
  FaRocket,
  FaClipboardCheck,
  FaLightbulb,
} from "react-icons/fa";
export const dBody = document.body;
export const dropFlowStyle = {
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
};

export const isMobile = window.screen.width < 768;

// ── Converts a "#rrggbb" (or "#rgb") hex color into an rgba() string.
// Used to derive theme-aware translucent tints (shadows, tinted glass
// backgrounds, hover overlays) directly from a theme's primary/accent
// color instead of hardcoding a fixed neutral tint everywhere.
export const hexToRgba = (hex, alpha = 1) => {
  if (!hex || typeof hex !== "string") return `rgba(15, 23, 42, ${alpha})`;
  const clean = hex.replace("#", "").trim();
  const full =
    clean.length === 3
      ? clean
          .split("")
          .map((c) => c + c)
          .join("")
      : clean;
  const bigint = parseInt(full, 16);
  if (Number.isNaN(bigint)) return `rgba(15, 23, 42, ${alpha})`;
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

// ── Shared fallback palette used by both ServiceCardThemeV2 and
// ServiceCardThemeV3 when the profile has no custom theme selected.
// Keeping this in one place means the two card components can never
// drift into showing different "default" colors for the same profile.
export const neutralDefaultTheme = {
  primary: "#161616",
  primaryHover: "#000000",
  accent: "#161616",
  background: "#ffffff",
  card: "#ffffff",
  cardHover: "#f1f5f9",
  cardForeground: "#0f172a",
  border: "#e2e8f0",
  thinBorder: "rgba(15, 23, 42, 0.12)",
  thinBg: "#f1f5f9",
  indiDot: "#161616",
  heading: "#ffffff",
  subHeading: "#e2e8f0",
  primaryColor: "#161616",
  secondary: "#ffffff",
  desText: "#64748b",
  tagtxtCol: "#334155",
  firstTagBg: "#f1f5f9",
  secTagBg: "#e2e8f0",
  thirdTagBg: "#eef2f7",
  lightGradeStart: "#f8fafc",
  lightGradeEnd: "#f1f5f9",
};

export const themesPallates = [
{
  /* ── "Ink & Paper" — editorial navy/cream/amber palette (dark-navy
     ink, warm cream paper, sage-green ticker accent, amber CTA).
     Selectable alternative theme (default is id 4, "Crimson & White"). ── */
  id: 1,
  primary: "#16212e",
  primaryHover: "#0e161f",
  accent: "#c98a3e",
  background: "#f6f2e8",
  card: "#fffdf8",
  cardForeground: "#16212e",
  cardHover: "#ece4d2",
  border: "#cfc5ac",
  thinBorder: "rgba(22, 33, 46, 0.2)",
  thinBg: "#f8f5ee",
  indiDot: "#3f6f5e",
  heading: "#f6f2e8",
  subHeading: "#cbd5ce",
  primaryColor: "#16212e",
  secondary: "#fffdf8",
  desText: "#2b3b4e",
  tagtxtCol: "#2b3b4e",
  firstTagBg: "rgba(22, 33, 46, 0.17)",
  secTagBg: "rgba(201, 138, 62, 0.3)",
  thirdTagBg: "rgba(63, 111, 94, 0.29)",
  lightGradeStart: "#faf7f0",
  lightGradeEnd: "#f3eee2",
},
{
  /* ── "Charcoal & Gold" — premium/modern palette (deep charcoal navy +
     muted gold accent + a teal tertiary for the ticker/today-highlight).
     Selectable alternative theme (default is id 4, "Crimson & White"). ── */
  id: 2,
  primary: "#10141c",
  primaryHover: "#1c2230",
  accent: "#c9a227",
  background: "#f7f6f3",
  card: "#ffffff",
  cardForeground: "#10141c",
  cardHover: "#ece7da",
  border: "#e3ded2",
  thinBorder: "rgba(16, 20, 28, 0.16)",
  thinBg: "#f2f0ea",
  indiDot: "#16a394",
  heading: "#f7f6f3",
  subHeading: "#c7c2b8",
  primaryColor: "#10141c",
  secondary: "#ffffff",
  desText: "#4b4a45",
  tagtxtCol: "#34322d",
  firstTagBg: "rgba(16, 20, 28, 0.15)",
  secTagBg: "rgba(201, 162, 39, 0.3)",
  thirdTagBg: "rgba(22, 163, 148, 0.29)",
  lightGradeStart: "#faf9f6",
  lightGradeEnd: "#f2efe6",
},
{
  /* ── "Cherry Cola & Butter Green" — cherry-cola deep reddish-brown as
     the primary/dark-panel color, a soft butter-green as the accent/CTA
     color, warm cream-vanilla as the background, and an aureolin-bistre
     golden-brown as the tertiary (ticker / "today" highlight) color.
     Selectable alternative theme (default is id 4, "Crimson & White"). ── */
  id: 3,
  primary: "#46201a",
  primaryHover: "#341712",
  accent: "#b7c167",
  background: "#fbf3e0",
  card: "#fffdf6",
  cardForeground: "#3b241c",
  cardHover: "#f3e6c8",
  border: "#e3d3b0",
  thinBorder: "rgba(70, 32, 26, 0.18)",
  thinBg: "#f7efdd",
  indiDot: "#8b5e34",
  heading: "#fbf3e0",
  subHeading: "#d9c9b0",
  primaryColor: "#46201a",
  secondary: "#fffdf6",
  desText: "#5c4636",
  tagtxtCol: "#4a3524",
  firstTagBg: "rgba(70, 32, 26, 0.17)",
  secTagBg: "rgba(183, 193, 103, 0.37)",
  thirdTagBg: "rgba(139, 94, 52, 0.31)",
  lightGradeStart: "#fdf8ec",
  lightGradeEnd: "#f6ead2",
},
{
  /* ── NEW DEFAULT: "Crimson & White" — built around #a00030, the
     brand red already hardcoded elsewhere in this app (header gradient,
     logout button, calendar hover), paired with its original navy
     partner (#000940, also from that same header gradient) as the
     tertiary/ticker color, on a clean white base. Matches the default
     :root values now set in servicedashbaord.css. ── */
  id: 4,
  primary: "#a00030",
  primaryHover: "#7a0025",
  accent: "#d1264f",
  background: "#ffffff",
  card: "#ffffff",
  cardForeground: "#1f2937",
  cardHover: "#fbe4e9",
  border: "#e5e7eb",
  thinBorder: "rgba(160, 0, 48, 0.2)",
  thinBg: "#fff5f7",
  indiDot: "#000940",
  heading: "#ffffff",
  subHeading: "#f6dbe1",
  primaryColor: "#a00030",
  secondary: "#ffffff",
  desText: "rgb(71, 85, 105)",
  tagtxtCol: "rgb(51, 65, 85)",
  firstTagBg: "rgba(160, 0, 48, 0.17)",
  secTagBg: "rgba(209, 38, 79, 0.3)",
  thirdTagBg: "rgba(0, 9, 64, 0.26)",
  lightGradeStart: "#fff5f7",
  lightGradeEnd: "#fdf0f2",
},
{
  id: 5,
  primary: "#0b2e33",
  primaryHover: "#082227",
  accent: "#e8674a",
  background: "#f4f1ea",
  card: "#ffffff",
  cardForeground: "#0b2e33",
  cardHover: "#f7ded6",
  border: "#dcd5c6",
  thinBorder: "rgba(11, 46, 51, 0.2)",
  thinBg: "#eef5f4",
  indiDot: "#2f9c8c",
  heading: "#f4f1ea",
  subHeading: "#bcd6d3",
  primaryColor: "#0b2e33",
  secondary: "#ffffff",
  desText: "#3d4d4e",
  tagtxtCol: "#2c3a3b",
  firstTagBg: "rgba(11, 46, 51, 0.17)",
  secTagBg: "rgba(232, 103, 74, 0.32)",
  thirdTagBg: "rgba(47, 156, 140, 0.31)",
  lightGradeStart: "#f0f6f5",
  lightGradeEnd: "#fbeee9",
},
{
  id: 6,
  primary: "#3b1f3a",
  primaryHover: "#2a1529",
  accent: "#e8c98a",
  background: "#faf6ee",
  card: "#ffffff",
  cardForeground: "#3b1f3a",
  cardHover: "#f2e6c8",
  border: "#e3d6c2",
  thinBorder: "rgba(59, 31, 58, 0.2)",
  thinBg: "#f7f0e4",
  indiDot: "#7a4e6b",
  heading: "#faf6ee",
  subHeading: "#d9c3d6",
  primaryColor: "#3b1f3a",
  secondary: "#ffffff",
  desText: "#4a3c49",
  tagtxtCol: "#392c37",
  firstTagBg: "rgba(59, 31, 58, 0.17)",
  secTagBg: "rgba(232, 201, 138, 0.37)",
  thirdTagBg: "rgba(122, 78, 107, 0.31)",
  lightGradeStart: "#faf3ee",
  lightGradeEnd: "#f4ecf3",
},
{
  id: 7,
  primary: "#1e2e22",
  primaryHover: "#152018",
  accent: "#c1683b",
  background: "#f3efe4",
  card: "#ffffff",
  cardForeground: "#1e2e22",
  cardHover: "#ecdcc9",
  border: "#ddd6c3",
  thinBorder: "rgba(30, 46, 34, 0.2)",
  thinBg: "#eef2ea",
  indiDot: "#5c8a6a",
  heading: "#f3efe4",
  subHeading: "#c3d3c6",
  primaryColor: "#1e2e22",
  secondary: "#ffffff",
  desText: "#3a4a3e",
  tagtxtCol: "#2b3830",
  firstTagBg: "rgba(30, 46, 34, 0.17)",
  secTagBg: "rgba(193, 104, 59, 0.32)",
  thirdTagBg: "rgba(92, 138, 106, 0.31)",
  lightGradeStart: "#f0f4ee",
  lightGradeEnd: "#fbeee5",
},
{
  id: 8,
  primary: "#2b1b14",
  primaryHover: "#1e120d",
  accent: "#e0a63a",
  background: "#faf3e7",
  card: "#ffffff",
  cardForeground: "#2b1b14",
  cardHover: "#f5e2bd",
  border: "#e6d9bd",
  thinBorder: "rgba(43, 27, 20, 0.2)",
  thinBg: "#f5ede0",
  indiDot: "#6b7a4a",
  heading: "#faf3e7",
  subHeading: "#d8c6a8",
  primaryColor: "#2b1b14",
  secondary: "#ffffff",
  desText: "#4a3a2e",
  tagtxtCol: "#392b21",
  firstTagBg: "rgba(43, 27, 20, 0.17)",
  secTagBg: "rgba(224, 166, 58, 0.34)",
  thirdTagBg: "rgba(107, 122, 74, 0.31)",
  lightGradeStart: "#faf3e6",
  lightGradeEnd: "#f2f0e2",
},
{
  id: 9,
  primary: "#14213d",
  primaryHover: "#0d1729",
  accent: "#b5602f",
  background: "#edf2f4",
  card: "#ffffff",
  cardForeground: "#14213d",
  cardHover: "#ead7c9",
  border: "#d6dee3",
  thinBorder: "rgba(20, 33, 61, 0.2)",
  thinBg: "#eef2f6",
  indiDot: "#3a6ea5",
  heading: "#edf2f4",
  subHeading: "#b9c6d6",
  primaryColor: "#14213d",
  secondary: "#ffffff",
  desText: "#374357",
  tagtxtCol: "#26314a",
  firstTagBg: "rgba(20, 33, 61, 0.17)",
  secTagBg: "rgba(181, 96, 47, 0.32)",
  thirdTagBg: "rgba(58, 110, 165, 0.31)",
  lightGradeStart: "#eef2f8",
  lightGradeEnd: "#faf0e9",
},
{
  id: 10,
  primary: "#4a1d2e",
  primaryHover: "#371522",
  accent: "#8fa98a",
  background: "#f7efea",
  card: "#ffffff",
  cardForeground: "#4a1d2e",
  cardHover: "#dde8db",
  border: "#e6d5cc",
  thinBorder: "rgba(74, 29, 46, 0.2)",
  thinBg: "#f6eeeb",
  indiDot: "#c08a5c",
  heading: "#f7efea",
  subHeading: "#d6bcc6",
  primaryColor: "#4a1d2e",
  secondary: "#ffffff",
  desText: "#523a42",
  tagtxtCol: "#3f2b32",
  firstTagBg: "rgba(74, 29, 46, 0.17)",
  secTagBg: "rgba(143, 169, 138, 0.37)",
  thirdTagBg: "rgba(192, 138, 92, 0.31)",
  lightGradeStart: "#f8f0eb",
  lightGradeEnd: "#f1f4ef",
},
{
  id: 11,
  primary: "#2b2d33",
  primaryHover: "#1e1f24",
  accent: "#e0857a",
  background: "#f5f2ed",
  card: "#ffffff",
  cardForeground: "#2b2d33",
  cardHover: "#f6ded9",
  border: "#dedbd3",
  thinBorder: "rgba(43, 45, 51, 0.2)",
  thinBg: "#f0efec",
  indiDot: "#7c8b7f",
  heading: "#f5f2ed",
  subHeading: "#c8c9cc",
  primaryColor: "#2b2d33",
  secondary: "#ffffff",
  desText: "#43454b",
  tagtxtCol: "#333338",
  firstTagBg: "rgba(43, 45, 51, 0.17)",
  secTagBg: "rgba(224, 133, 122, 0.32)",
  thirdTagBg: "rgba(124, 139, 127, 0.31)",
  lightGradeStart: "#f2f1ee",
  lightGradeEnd: "#faeeeb",
},
];

export const serviceIcons = [
  {
    id: 1,
    icon: <FaBriefcase size={24} strokeWidth={2} />,
  },
  {
    id: 2,
    icon: <FaLaptopCode size={24} strokeWidth={2} />,
  },
  {
    id: 3,
    icon: <FaChartLine size={24} strokeWidth={2} />,
  },
  {
    id: 4,
    icon: <FaPaintBrush size={24} strokeWidth={2} />,
  },
  {
    id: 5,
    icon: <FaHeadset size={24} strokeWidth={2} />,
  },
  {
    id: 6,
    icon: <FaShieldAlt size={24} strokeWidth={2} />,
  },
  {
    id: 7,
    icon: <FaCloud size={24} strokeWidth={2} />,
  },
  {
    id: 8,
    icon: <FaBullhorn size={24} strokeWidth={2} />,
  },
  {
    id: 9,
    icon: <FaCog size={24} strokeWidth={2} />,
  },
  {
    id: 10,
    icon: <FaUsers size={24} strokeWidth={2} />,
  },
  {
    id: 11,
    icon: <FaDatabase size={24} strokeWidth={2} />,
  },
  {
    id: 12,
    icon: <FaGlobe size={24} strokeWidth={2} />,
  },
  {
    id: 13,
    icon: <FaRocket size={24} strokeWidth={2} />,
  },
  {
    id: 14,
    icon: <FaClipboardCheck size={24} strokeWidth={2} />,
  },
  {
    id: 15,
    icon: <FaLightbulb size={24} strokeWidth={2} />,
  },
];